import { api, BASE } from './client'

export interface MediaFile {
  id: string
  owner_id: string
  sha256: string
  file_name: string
  mime_type: string
  size: number
  width: number
  height: number
  status: string
  created_at: string
}

export interface StickerItem {
  id: string
  file_id: string
  emoji: string
}

export interface StickerPack {
  id: string
  name: string
  thumbnail?: string
  items?: StickerItem[]
}

export const mediaApi = {
  upload: (file: File, noConvert = false): Promise<MediaFile> => {
    const form = new FormData()
    form.append('file', file)
    const path = noConvert ? '/v1/media/upload?no_convert=1' : '/v1/media/upload'
    return api.upload<MediaFile>(path, form)
  },

  getURL: (fileId: string) => `${BASE}/v1/media/${fileId}/url`,

  getInfo: (fileId: string): Promise<MediaFile> => api.get(`/v1/media/${fileId}`),

  getThumbnailURL: (fileId: string, size: '200x200' | '800x800') =>
    `${BASE}/v1/media/${fileId}/thumbnails/${size}`,

  delete: (fileId: string) => api.delete(`/v1/media/${fileId}`),

  getStickerPacks: (): Promise<{ packs: StickerPack[] }> =>
    api.get('/v1/media/stickers/my'),

  getPublicStickerPacks: (): Promise<{ packs: StickerPack[] }> =>
    api.get('/v1/media/stickers/packs'),

  installStickerPack: (packId: string): Promise<void> =>
    api.post(`/v1/media/stickers/packs/${packId}/install`, {}),

  uninstallStickerPack: (packId: string): Promise<void> =>
    api.delete(`/v1/media/stickers/packs/${packId}/install`),

  listMyFiles: (limit = 50, offset = 0): Promise<{ files: MediaFile[] }> =>
    api.get(`/v1/media/files?limit=${limit}&offset=${offset}`),

  createStickerPack: (name: string, thumbnail: string, isPublic: boolean): Promise<StickerPack> =>
    api.post('/v1/media/stickers/packs', { name, thumbnail, is_public: isPublic }),

  updateStickerPack: (packId: string, data: { name?: string; thumbnail?: string; is_public?: boolean }): Promise<StickerPack> =>
    api.put(`/v1/media/stickers/packs/${packId}`, data),

  deleteStickerPack: (packId: string): Promise<void> =>
    api.delete(`/v1/media/stickers/packs/${packId}`),

  addStickerItem: (packId: string, fileId: string, emoji: string): Promise<StickerItem> =>
    api.post(`/v1/media/stickers/packs/${packId}/items`, { file_id: fileId, emoji }),

  removeStickerItem: (packId: string, itemId: string): Promise<void> =>
    api.delete(`/v1/media/stickers/packs/${packId}/items/${itemId}`),
}
